import React, { Component } from 'react'
import './Team.css'; 

export default class Team extends Component {
  render() {
    return (
      <div className ="team">
          <h2 className = "h2Aboutus"> About us</h2>
         
          <p className ="pAboutus"> Our project includes three ambitious peoples: two back-end developers and one front-end.
            
     </p>
          </div>
    )
  }
}
